


































































































































import Vue from "vue";
import LazyVideoThumbnail from "@/components/LazyVideoThumbnail.vue";
import ProjectDetailsOverlay from "@/components/ProjectDetailsOverlay.vue";
import gameProjectsData from "@/data/GameProjectsData.ts";
import ProjectData from "@/data/ProjectData.ts";

export default Vue.extend({
  name: "GameProjects",
  components: {
    LazyVideoThumbnail,
    ProjectDetailsOverlay,
  },
  data: function () {
    return {
      projects: gameProjectsData,
      projectRows: {
        dispater: "normal",
        "drag-rush": "reverse",
        "floor-0": "normal",
        "swing-space": "reverse",
      },
      thumbVideos: {
        "cpp-sokoban": "img/projects/cpp-sokoban/currentprogress.mp4",
        "drag-rush": "img/projects/drag-rush/DragRushGif.mp4",
        dispater: "img/projects/dispater/DispaterGif.mp4",
        "floor-0": "img/projects/floor-0/Floor0vid2-web.mp4",
        "swing-space": "img/projects/swing-space/SwingSpaceVid-thumb.mp4",
      },
      thumbPosters: {
        "cpp-sokoban": "img/projects/cpp-sokoban/super-mario-icons-square-yellow-box-with-question-mark-illustration-thumbnail.jpg",
        "drag-rush": "img/projects/drag-rush/DragRushGif-poster.webp",
        dispater: "img/projects/dispater/DispaterGif-poster.webp",
        "floor-0": "img/projects/floor-0/Floor0gif1-poster.webp",
        "swing-space": "img/projects/swing-space/SwingSpaceVid-thumb-poster.webp",
      },
      roles: {
        "cpp-sokoban": [
          "Solo project, C++ and SDL3, no engine",
          "Custom memory arena and data-oriented entities",
          "Hot-reloadable game logic DLL",
        ],
        "drag-rush": [
          "Team of 6 (3 programmers, 3 artists), Unity, 8 weeks",
          "Built the vehicle animation trees",
          "Helped finalize the Beat Conductor",
        ],
        dispater: [
          "Team of 7 (3 programmers, 4 artists), Unreal Engine, 8 weeks",
          "Built the dialogue, task and interaction systems",
          "Audio engineering",
        ],
        "floor-0": [
          "Solo project, Unreal Engine, 5 weeks",
          "Multi-state ghost AI built with a behaviour tree",
          "Custom key/lock and interaction systems",
        ],
        "swing-space": [
          "Solo project, Unity, 5 weeks",
          "Grapple swing movement and targeting",
          "Firebase global highscores, ported to mobile",
        ],
      },
      awards: {
        dispater: {
          logo: "img/projects/dispater/sga-new-talent-2026.png",
          event: "Swedish Game Awards New Talent 2026",
          status: "Nominee",
          category: "Best Audio",
        },
      } as Record<string, { logo: string; event: string; status: string; category: string }>,
      summaries: {
        "cpp-sokoban": "A Sokoban puzzle game built from scratch in SDL3 + C++. Unfinished, but the most technically hands-on project here: a custom memory arena, data-oriented design, and a hot-reloadable game-logic DLL.",
        "drag-rush": "\"Are you dragging or are you rushing!?\" Drag Rush is a racing game where you need to stick to the beat. Swerve and shoot your way through the race-track and beat the first-place holder.",
        dispater: "Dig for your salvation in this narrative heavy experience. Lead the crew down an unexplored path and discover the truth behind its walls.",
        "floor-0": "You wake up in a house you don't remember setting your foot in. Can you find a way out before the horrors haunting this place find you?",
        "swing-space": "Swing yourself up through space by grappling planets, push your run farther, and chase the highscore.",
      },
      showPopup: false,
      popupTitle: "",
      popupColor: "#000000",
      popupContent: "",
    };
  },
  computed: {
    wipProject: function (): ProjectData | undefined {
      return this.projects.find((p: ProjectData) => p.id === "cpp-sokoban");
    },
    timelineProjects: function (): ProjectData[] {
      // Timeline order follows the projectRows keys, not the data file order
      return Object.keys(this.projectRows)
        .map((id: string) => this.projects.find((p: ProjectData) => p.id === id))
        .filter((p: ProjectData | undefined): p is ProjectData => p !== undefined);
    },
  },
  mounted: function () {
    const projectId = this.$route.query.project;
    if (typeof projectId === "string") {
      const project = this.projects.find((p: ProjectData) => p.id === projectId);
      if (project) {
        window.scrollTo(0, 0);
        this.showDetails(project);
      }
    }
  },
  methods: {
    showDetails: function (item: ProjectData) {
      this.popupTitle = item.name;
      this.popupColor = item.accentColor;
      this.popupContent = item.htmlDescription;
      this.showPopup = true;
    },
  },
});
